import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { doFetchStatistics, doUpdateStatistics } from "./statistics.action";
import { StatisticsResponse } from "../config";

interface StatsState {
  data: StatisticsResponse["data"] | null;
  loading: boolean;
  error: string | null;
}

const initialState: StatsState = {
  data: null,
  loading: false,
  error: null,
};

const statsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Statistics
      .addCase(doFetchStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(doFetchStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(doUpdateStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        doUpdateStatistics.fulfilled,
        (state, action: PayloadAction<Partial<StatisticsResponse["data"]>>) => {
          state.loading = false;
          if (state.data) {
            state.data = { ...state.data, ...action.payload };
          }
        }
      )
      .addCase(doUpdateStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default statsSlice.reducer;
